/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import {App} from '../App'
import {AuthPage, Logout, useAuth} from '../modules/auth'
import {AuthLayout} from '../modules/auth/AuthLayout'
import {CustomError} from '../modules/errors/components/CustomError'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {DigitalCard} from '../modules/registration/DigitalCard'
import {Registration} from '../modules/registration/Registration'
import {PrivateRoutes} from './PrivateRoutes'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/companies' />} />
            </>
          ) : (
            <Route element={<AuthLayout />}>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='registration/:token' element={<Registration />} />
              <Route path='digitalcard' element={<DigitalCard />} />
              <Route path='error' element={<CustomError />} />
              <Route path='*' element={<Navigate to='digitalcard' />} />
            </Route>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
